import LogoFut from "../componentsStyled/icon/LogoFut";
import styled from "styled-components";

const Header = () => {
    return(
        <section className="c-header">
            <LogoFut className="logo-header"></LogoFut>
        </section>         
    )
}
export default Header;